import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import theme from './vuetify/theme';

Vue.use(Vuetify)

const config = {
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: theme[localStorage.getItem('workspace')] || theme.blue,
        },
    },
};

export default new Vuetify(config)
